import { BLOCK_OPENAPI, type BlockOpenAPIData } from '@gitbook/doc-core';
import type { Block } from '@gitbook/slate';

import type { GastToHastTransformMap } from './types';
import { createCustomBlock } from './utils';

/**
 * Convert a swagger block into HTML nodes.
 */
export const transformBlocksSwagger: GastToHastTransformMap<Block> = {
    [BLOCK_OPENAPI]: async (node, _eat, options) => {
        const data = node.data.toFrozenObject() as BlockOpenAPIData;

        const resolved = await options.resolveContentRef(data.ref);
        if (!resolved) {
            return [];
        }

        return [
            createCustomBlock(
                'openapi',
                {
                    src: resolved.url,
                    path: data.path,
                    method: data.method,
                    ...(typeof data.expanded !== 'undefined'
                        ? { expanded: `${Boolean(data.expanded)}` }
                        : undefined),
                    ...(typeof data.fullWidth !== 'undefined'
                        ? { fullWidth: `${Boolean(data.fullWidth)}` }
                        : undefined),
                },
                [
                    {
                        type: 'element',
                        tagName: 'a',
                        properties: {
                            href: resolved.url,
                        },
                        children: [
                            {
                                type: 'text',
                                value: resolved.text,
                            },
                        ],
                    },
                ]
            ),
        ];
    },
};
